module.exports = __webpack_public_path__ + "img/tjcg.7bb838d5.png";